// Miro icon for the Integration Sync strip and modals. Jira's is the shared one.
export { JiraIcon } from '../../item-list/ItemImportSourceChooser';

// reuse-ack: differs from src/components/prioritization/item-list/ItemImportSourceChooser.tsx MiroIcon — this panel draws the full Miro logo, the chooser a simplified mark; kept so this refactor changes no pixels
export const MiroIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
    <path d="M17.392 0H13.9L17 4.808 10.592 0H7.1L12.1 7.385 3.392 0H0l9.592 11.196L0 24h3.392L12.1 12.017 7.1 24h3.492l6.408-14.4L13.9 24h3.492L24 10.588V0h-6.608z" />
  </svg>
);
